import theme from "@/theme";

export const styles = {
  page: {
    display: "flex",
    gap: "24px",
    width: "100%",
    maxWidth: "1004px",
    margin: "0 auto",
    padding: "10px 20px 40px",
    boxSizing: "border-box",
    alignItems: "flex-start",
  },
  listColumn: {
    flex: "1 1 0",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },
  sectionLabel: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "16px",
    color: theme.palette.custom.blueGray600,
    padding: "10px 14px",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minHeight: "calc(100vh - 200px)",
    color: theme.palette.custom.blueGray600,
    textAlign: "center",
  },
  loaderBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "calc(100vh - 200px)",
  },
};
